export const TASKS = {
  FETCH_TASKS: 'FETCH_TASKS',
  UPDATE_BADGE_COUNT: 'UPDATE_BADGE_COUNT_TASKS',
  START_FETCH_TASK: 'START_FETCH_TASK',
  SET_ACTIVE_TASK: 'SET_ACTIVE_TASK',
  END_FETCH_TASK: 'START_FETCH_TASK'
};
